function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash.uniqueid';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { Col, CustomInput, ListGroup, ListGroupItem, Row, ScrollContainer } from '@appfolio/react-gears';
import FilterHeader from "./FilterHeader";
import SortHeader from "./SortHeader";
import ListItem from "./ListItem";
import useMap from "../hooks/useMap";

var List = function List(_ref) {
  var render = _ref.children,
      filter = _ref.filter,
      filterPlaceholder = _ref.filterPlaceholder,
      flush = _ref.flush,
      header = _ref.header,
      height = _ref.height,
      scrollPositionKey = _ref.scrollPositionKey,
      itemClassName = _ref.itemClassName,
      items = _ref.items,
      onExpand = _ref.onExpand,
      onFilter = _ref.onFilter,
      onSelect = _ref.onSelect,
      onSort = _ref.onSort,
      select = _ref.select,
      selected = _ref.selected,
      selectedKeyMapper = _ref.selectedKeyMapper,
      sort = _ref.sort,
      sortByLabel = _ref.sortByLabel,
      sortOptions = _ref.sortOptions,
      props = _objectWithoutProperties(_ref, ["children", "filter", "filterPlaceholder", "flush", "header", "height", "scrollPositionKey", "itemClassName", "items", "onExpand", "onFilter", "onSelect", "onSort", "select", "selected", "selectedKeyMapper", "sort", "sortByLabel", "sortOptions"]);

  var _useMap = useMap(selected, selectedKeyMapper),
      selection = _useMap.map,
      hasItem = _useMap.has,
      addItem = _useMap.add,
      removeItem = _useMap.remove,
      clearSelection = _useMap.clear,
      replaceSelection = _useMap.replace;

  var _useState = useState(function () {
    return uniqueId('selectall-');
  }),
      _useState2 = _slicedToArray(_useState, 1),
      selectAllId = _useState2[0];

  var selectAllRef = useRef();
  useDeepCompareEffect(function () {
    return onSelect(Array.from(selection.values()));
  }, [Array.from(selection.values()), onSelect]);
  useDeepCompareEffect(function () {
    return replaceSelection(selected);
  }, [selected, replaceSelection]);
  useDeepCompareEffect(function () {
    var includes = function includes(xs, x) {
      return xs.map(selectedKeyMapper).includes(selectedKeyMapper(x));
    };

    selection.forEach(function (item) {
      if (!includes(items, item)) removeItem(item);
    });
  }, [items, Array.from(selection.values()), selectedKeyMapper]);
  useDeepCompareEffect(function () {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = items.length > 0 && selection.size > 0 && selection.size !== items.length;
    }
  }, [items, Array.from(selection.values())]);

  var handleSelection = function handleSelection(item, checked) {
    if (select === 'checkbox' || select === 'switch') {
      if (hasItem(item) && !checked) removeItem(item);else if (checked) addItem(item);
    } else if (!hasItem(item)) {
      clearSelection();
      addItem(item);
    }
  };

  var handleSelectAll = function handleSelectAll() {
    if (selection.size === items.length) replaceSelection();else replaceSelection(items);
  };

  var _useState3 = useState(sort.property),
      _useState4 = _slicedToArray(_useState3, 2),
      sortProperty = _useState4[0],
      setSortProperty = _useState4[1];

  var ascendingInitial = sort.ascending === undefined ? true : sort.ascending;

  var _useState5 = useState(ascendingInitial),
      _useState6 = _slicedToArray(_useState5, 2),
      ascending = _useState6[0],
      setAscending = _useState6[1];

  useEffect(function () {
    if (!onSort) {
      return;
    }

    if (ascending !== ascendingInitial || sortProperty !== sort.property) {
      onSort({
        property: sortProperty,
        ascending: ascending
      });
    }
  }, [ascending, ascendingInitial, onSort, sort.property, sortProperty]);
  var showHeader = header || select === 'checkbox' || select === 'switch' || onFilter || onSort;
  return (
    /*#__PURE__*/
    React.createElement(ListGroup, _extends({
      flush: flush,
      tag: "div"
    }, props), showHeader &&
    /*#__PURE__*/
    React.createElement(ListGroupItem, {
      tag: "header",
      className: "d-flex align-items-center bg-secondary js-header"
    }, select && select !== 'radio' &&
    /*#__PURE__*/
    React.createElement("div", {
      className: "h-100 d-flex align-items-center mr-3"
    },
    /*#__PURE__*/
    React.createElement(CustomInput, {
      id: selectAllId,
      type: select,
      checked: items.length && selection.size === items.length,
      disabled: items.length === 0,
      label:
      /*#__PURE__*/
      React.createElement("span", {
        className: "sr-only"
      }, "Select all"),
      onChange: function onChange() {
        return handleSelectAll();
      },
      innerRef: selectAllRef
    })),
    /*#__PURE__*/
    React.createElement("div", {
      className: "w-100"
    }, !sortOptions && !onFilter ? header :
    /*#__PURE__*/
    React.createElement(Row, {
      className: "no-gutters"
    },
    /*#__PURE__*/
    React.createElement(Col, {
      xs: "12",
      sm: "6",
      md: "4"
    }, header, !header && onFilter &&
    /*#__PURE__*/
    React.createElement(FilterHeader, {
      placeholder: filterPlaceholder,
      onChange: onFilter,
      value: filter
    })), sortOptions &&
    /*#__PURE__*/
    React.createElement(SortHeader, {
      ascending: ascending,
      sortByLabel: sortByLabel,
      sortOptions: sortOptions,
      sortProperty: sortProperty,
      onChangeAscending: setAscending,
      onChangeProperty: setSortProperty
    })))),
    /*#__PURE__*/
    React.createElement(ScrollContainer, {
      height: height,
      scrollPositionKey: scrollPositionKey
    },
    /*#__PURE__*/
    React.createElement(ListGroup, {
      flush: flush
    }, items.map(function (item, i) {
      return (
        /*#__PURE__*/
        React.createElement(ListItem, {
          className: itemClassName,
          expanded: item.expanded || false,
          item: item,
          key: item.key || i,
          select: select,
          selected: hasItem(item),
          onSelect: handleSelection,
          onExpand: onExpand
        }, render)
      );
    }))))
  );
};

List.displayName = "List";
List.propTypes = _objectSpread({}, ListGroup.propTypes, {
  children: PropTypes.func,
  filter: PropTypes.string,
  filterPlaceholder: PropTypes.string,
  header: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  scrollPositionKey: PropTypes.string,
  onExpand: PropTypes.func,
  onFilter: PropTypes.func,
  itemClassName: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  select: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onSelect: PropTypes.func,
  onSort: PropTypes.func,
  selectedKeyMapper: PropTypes.func,
  sort: PropTypes.shape({
    property: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    ascending: PropTypes.bool
  }),
  sortByLabel: PropTypes.string,
  sortOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
});
List.defaultProps = {
  children: function children() {
    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null)
    );
  },
  filterPlaceholder: 'Search',
  items: [],
  onSelect: function onSelect() {},
  select: '',
  selected: [],
  selectedKeyMapper: function selectedKeyMapper(x) {
    return x;
  },
  sort: {},
  sortByLabel: 'Sort by'
};
export default List;